import { SET_RES_AVAILABLE_DATE} from '../actions';

const reservationdate = (state = [], action) => {
  switch (action.type) {
    case SET_RES_AVAILABLE_DATE:
      return [...action.value];
    default: return state;
  }
}

export default reservationdate;